import React, { useMemo } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "components/Sidebar/Sidebar.js";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import PageHeader from "components/ui/PageHeader";
import rhRoutes from "RhRoutes";
import useCurrentUser from "hooks/useCurrentUser";

const greeting = () => {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 18) return "Good afternoon";
  return "Good evening";
};

const RHLayout = () => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const { user } = useCurrentUser() || {};

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (rts) =>
    rts.map((p, k) =>
      p.layout === "/rh" ? <Route path={p.path} element={p.component} key={k} /> : null
    );

  const sidebarRoutes = useMemo(
    () => rhRoutes.filter((r) => r.sidebar !== false),
    []
  );

  const brandText = useMemo(() => {
    for (let r of rhRoutes) {
      if (location.pathname.includes((r.layout || "") + r.path)) return r.name;
    }
    return "HR";
  }, [location.pathname]);

  const branchName = user?.branch?.name || "Branch";
  const userName = user?.firstName || (user?.email ? user.email.split("@")[0] : "");

  return (
    <>
      <Sidebar routes={sidebarRoutes} logo={{ innerLink: "/rh/dashboard" }} />
      <main className="pm-main" ref={mainContent}>
        <AdminNavbar brandText={brandText} profilePath="/rh/profile" />
        <PageHeader
          role="rh"
          eyebrow={`${branchName} · Human Resources`}
          title={userName ? `${greeting()}, ${userName}` : brandText}
          subtitle={brandText}
        />
        <div className="ph-pull">
          <Routes>
            {getRoutes(rhRoutes)}
            <Route path="*" element={<Navigate to="/rh/dashboard" replace />} />
          </Routes>
        </div>
        <AdminFooter />
      </main>
    </>
  );
};

export default RHLayout;